"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _labelConsts = require("../../constants/labelConsts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const InfoTypography = (0, _styles.styled)(_Typography.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    color: theme.palette.infomation.primary,
    fontWeight: 'bold',
    fontSize: theme.typography.body2.fontSize
  };
});
const actions = {
  register: 'register',
  update: 'update',
  delete: 'delete'
};

/**
 * アクションメッセージ部品
 * @prop {string} [action] - アクションの種類[ 'register', 'update',  'delete']
 * @prop {object} [supplement] - 補足テキスト
 */
const ActionMessage = function (props) {
  const {
    intl,
    className,
    action,
    supplement,
    children
  } = props;
  let message;
  if (action) {
    switch (action) {
      case actions.register:
        message = intl.formatMessage({
          id: _labelConsts.LABEL.CORE_REGISTERED_MESSAGE
        });
        break;
      case actions.update:
        message = intl.formatMessage({
          id: _labelConsts.LABEL.CORE_UPDATED_MESSAGE
        });
        break;
      case actions.delete:
        message = intl.formatMessage({
          id: _labelConsts.LABEL.CORE_DELETED_MESSAGE
        });
        break;
      default:
    }
  } else {
    message = children;
  }
  return /*#__PURE__*/_react.default.createElement(InfoTypography, {
    className: className
  }, message, supplement && /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("br", null), supplement));
};
ActionMessage.propTypes = {
  action: _propTypes.default.oneOf(Object.values(actions)),
  supplement: _propTypes.default.node
};
var _default = exports.default = (0, _reactIntl.injectIntl)(ActionMessage);